/**
 * Het hartje in de header, met hetzelfde bolletje als de winkelmand.
 *
 * Alleen zichtbaar als er iets in de lijst staat. De eerste stand zet een
 * inline script in header-actions.liquid, zodat de mand niet nà het laden
 * opschuift. Dit bestand houdt de stand bij ná toggle (WISHLIST_CHANGE).
 */

import { wishlist, WISHLIST_CHANGE } from '@theme/wishlist-store';
import { whenPageActive } from '@theme/hds-page-activation';

function render() {
  const count = wishlist.count();
  const display = count < 100 ? String(count) : '';

  for (const node of document.querySelectorAll('[data-wishlist-count]')) {
    node.textContent = display;

    const link = node.closest('.action__wishlist');
    if (link) link.hidden = count === 0;

    const label = node.dataset.countLabel;
    if (label) link?.setAttribute('aria-label', label.replaceAll('{count}', String(count)));
  }
}

document.addEventListener(WISHLIST_CHANGE, render);
window.addEventListener('pageshow', render);
window.addEventListener('storage', (event) => {
  if (event.key === 'hds:wishlist:v1') render();
});
whenPageActive(render);

/**
 * De herkomst van de klik onthouden in plaats van hier een event publiceren.
 * Een klik op deze link navigeert meteen; Shopify.analytics.publish verwerkt
 * asynchroon, dus zo'n event gaat onderweg verloren. De verlanglijstpagina
 * publiceert het straks mét deze herkomst erbij.
 */
document.addEventListener('click', (event) => {
  const link = event.target.closest('.action__wishlist, [data-wishlist-open]');
  if (!link) return;
  try {
    sessionStorage.setItem('hds:wishlist:source', link.dataset.wishlistOpen || 'header');
  } catch {
    /* zonder sessionStorage meten we simpelweg 'direct' */
  }
});
